function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_674",
  d: "M24.333 3H5.667A2.675 2.675 0 0 0 3 5.667v18.666A2.675 2.675 0 0 0 5.667 27h18.666A2.675 2.675 0 0 0 27 24.333V5.667A2.675 2.675 0 0 0 24.333 3zm0 21.333H5.667V5.667h18.666z",
  className: "cls-1",
  transform: "translate(-3 -3)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "\\uC0AC\\uAC01\\uD615_1002",
  d: "M0 0H2.667V6.667H0z",
  className: "cls-1",
  transform: "translate(5.333 12)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "\\uC0AC\\uAC01\\uD615_1003",
  d: "M0 0H2.667V13.333H0z",
  className: "cls-1",
  transform: "translate(16 5.333)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "\\uC0AC\\uAC01\\uD615_1004",
  d: "M0 0H2.667V4H0z",
  className: "cls-1",
  transform: "translate(10.667 14.667)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "\\uC0AC\\uAC01\\uD615_1005",
  d: "M0 0H2.667V2.667H0z",
  className: "cls-1",
  transform: "translate(10.667 9.333)"
});

function SvgIconAnalytics1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_analytics_-1",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnalytics1);
export default __webpack_public_path__ + "static/media/icon-analytics-1.bb14b87e.svg";
export { ForwardRef as ReactComponent };